import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, MessageSquare } from "lucide-react";
import { handleGet } from "../../../controllers/controller.all";

export default function ChatConversation() {
    const { id } = useParams();
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchMessages = async () => {
        setLoading(true);
        // We will attempt a standard route for picking up messages
        await handleGet(`/chat_detail/chat/${id}`, (res) => {
            if (res?.chat_details) {
                setMessages(res.chat_details);
            } else if (Array.isArray(res)) {
                setMessages(res);
            }
        }, token);
        setLoading(false);
    };

    useEffect(() => {
        if(token && id) fetchMessages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, token]);

    return (
        <div className="flex flex-col gap-6 max-w-4xl mx-auto h-[80vh]">
            <div className="flex items-center justify-between border-b border-gray-200 pb-4">
                <div className="flex items-center gap-4">
                    <Link to="/chats" className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-500">
                        <ArrowLeft className="h-5 w-5" />
                    </Link>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Détail de la conversation</h1>
                        <p className="text-sm text-gray-500">Consultation en mode lecture seule.</p>
                    </div>
                </div>
            </div>

            <div className="bg-gray-50 flex-1 rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                <div className="flex-1 overflow-y-auto p-6 space-y-4">
                    {loading ? (
                        <div className="flex justify-center py-10">
                            <span className="text-sm text-gray-500">Chargement des messages...</span>
                        </div>
                    ) : messages.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-20 text-gray-500">
                            <MessageSquare className="h-12 w-12 text-gray-300 mb-3" />
                            <p>Aucun message dans cette conversation.</p>
                        </div>
                    ) : (
                        messages.map((msg, idx) => {
                            const isMe = msg.sender?._id === user?._id || msg.sender === user?._id;
                            return (
                                <div key={msg._id || idx} className={`flex ${isMe ? 'justify-end' : 'justify-start'}`}>
                                    <div className={`max-w-[70%] rounded-2xl px-5 py-3 ${isMe ? 'bg-indigo-600 text-white rounded-br-none' : 'bg-white border border-gray-200 text-gray-900 rounded-bl-none shadow-sm'}`}>
                                        {!isMe && msg.sender && (
                                            <div className="text-xs font-semibold text-indigo-600 mb-1">
                                                {msg.sender.nom ? msg.sender.prenom + " " + msg.sender.nom : "Inexistant"}
                                            </div>
                                        )}
                                        <p className="text-sm whitespace-pre-wrap">{msg.message || msg.content}</p>
                                        <div className={`text-[10px] mt-2 text-right ${isMe ? 'text-indigo-200' : 'text-gray-400'}`}>
                                            {msg.created_at}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
}
